import type { DeviceValidationBreakdown } from './types/DeviceValidationTypes';
import type { RaceValidationReportRow } from '../components/shared/types/ValidationReportTypes';
import {
  groupDevicesForValidationReport,
  isFrontDeviceId,
  type DeviceAssignmentRef,
} from './devicePairing';

export function buildRaceValidationReportRows(params: {
  devices: DeviceAssignmentRef[];
  getBreakdown: (deviceId: string, frontDeviceId?: string) => DeviceValidationBreakdown;
}): RaceValidationReportRow[] {
  const { groups, standalone } = groupDevicesForValidationReport(params.devices);
  const out: RaceValidationReportRow[] = [];

  for (const g of groups) {
    const frontDeviceId = g.frontDeviceId || undefined;
    out.push({
      deviceId: g.rearDeviceId,
      frontDeviceId,
      breakdown: params.getBreakdown(g.rearDeviceId, frontDeviceId),
    });
  }

  for (const device of standalone) {
    const id = String(device.deviceId ?? '').trim();
    if (!id || isFrontDeviceId(id)) continue;
    out.push({
      deviceId: id,
      breakdown: params.getBreakdown(id),
    });
  }

  out.sort((a, b) => {
    const aFail = a.breakdown.notes ? 0 : 1;
    const bFail = b.breakdown.notes ? 0 : 1;
    if (aFail !== bFail) return aFail - bFail;
    return a.deviceId.localeCompare(b.deviceId);
  });

  return out;
}
